export const zh = {
  meta: {
    title: 'AuthFlow™ - 基于 JWT 令牌的简单邮箱/密码身份验证',
    description: '为现代 Web 应用提供可靠的邮箱/密码身份验证和 JWT 令牌。与复杂的平台不同，我们专注于真正有效的方案：开发者可以信赖的安全、简单的登录。',
  },
  // Navigation
  nav: {
    home: '首页',
    features: '功能',
    pricing: '定价',
    compare: '对比',
    contact: '联系我们',
    getStarted: '开始使用',
    signIn: '登录',
  },
  // Dashboard
  dashboard: {
    title: '仪表板',
    users: '用户',
    activity: '活动',
    settings: '设置',
    logout: '登出',
    profileSettings: '个人资料设置',
    activityLog: '活动日志',
    welcome: '欢迎来到您的仪表板',
    welcomeBack: '欢迎回来，{name}。这是您的身份验证服务的最新情况。',
    totalUsers: '总用户数',
    activeUsers: '活跃用户',
    totalLogins: '总登录次数',
    recentActivity: '最近活动',
    noRecentActivity: '暂无最近活动',
    userSettings: '用户设置',
    organizationOwnerCannotBeManaged: '组织所有者无法被管理',
    configureSettings: '配置设置',
    hereIsWhatsHappening: '这是您的身份验证服务的最新情况。',
    fromLastMonth: '较上月',
    monthlyLogins: '月度登录',
    successRate: '成功率',
    latestAuthEvents: '最新的身份验证事件和系统更新',
    viewAllActivity: '查看所有活动',
    userManagement: '用户管理',
    manageApplicationUsers: '管理您的应用程序用户',
    viewAllUsers: '查看所有用户',
    apiKeys: 'API 密钥',
    manageApiKeys: '管理您的身份验证 API 密钥',
    systemStatus: '系统状态',
    authenticationApi: '身份验证 API',
    operational: '正常运行',
    userManagementService: '用户管理',
    searchUsers: '搜索用户...',
    all: '全部',
    active: '活跃',
    inactive: '不活跃',
    lastLogin: '最后登录',
    never: '从未',
    admin: '管理员',
    owner: '所有者',
    noUsersFound: '未找到符合条件的用户',
    noUsers: '未找到用户',
    for: '关于',
    noApiKeyFound: '未找到 API 密钥',
    hideApiKey: '隐藏 API 密钥',
    showApiKey: '显示 API 密钥',
    created: '创建时间',
    success: '成功',
    warning: '警告',
    info: '信息',
    system: '系统',
    justNow: '刚刚',
    minutesAgo: '分钟前',
    hoursAgo: '小时前',
    daysAgo: '天前',
    notifications: '通知',
    billingReminder: '账单提醒',
    noNewNotifications: '暂无新通知',
    logOut: '退出登录',
  },
  // Hero Section
  hero: {
    badge: '受10,000+开发者信任',
    title: '电子邮件/密码认证',
    subtitle: '做得正确',
    description: '使用JWT令牌的简单、可靠的电子邮件/密码登录。与复杂的认证平台不同，我们专注于重要的事情：安全认证，只需工作即可。',
    startTrial: '开始免费试用',
    getStarted: '开始使用',
    trialNote: '无需信用卡 • 10 个月活跃用户免费',
    metrics: {
      firstIntegrationValue: '5 分钟',
      firstIntegrationLabel: '到首次集成',
      predictableSessionsValue: 'JWT',
      predictableSessionsLabel: '保持可预测的会话',
      noMazeValue: '零迷宫',
      noMazeLabel: '给只想让认证可靠工作的团队',
    },
    missionControlLabel: '认证任务中枢',
    missionControlTitle: '用户认证，无需迷宫',
    missionControlStatus: '稳定',
    sessionLayer: '会话层',
    emailPasswordSignIn: '邮箱/密码登录',
    roleAwareVerification: '角色感知验证',
    validated: '已验证',
    live: '在线',
    integrationShapeLabel: '集成形态',
    integrationShapeValue: '小而清晰的 API 流程',
    forTeamsLabel: '适合团队',
    forTeamsValue: '专注交付产品，而不是做 IAM 项目',
  },

  // Features
  features: {
    title: '为什么AuthFlow™不同',
    description: '我们专注于使用JWT令牌的电子邮件/密码认证 - 安全Web应用程序的基础。与试图做所有事情的平台不同，我们出色地做一件事情。',
    emailPassword: {
      title: '电子邮件/密码登录',
      description: '简单、安全的电子邮件和密码认证，可靠工作。没有复杂的流程或不必要的功能 - 只是您的用户理解的登录。',
    },
    jwtTokens: {
      title: 'JWT令牌管理',
      description: '正确的JWT令牌处理会话，具有安全存储和自动刷新。行业标准的令牌，与您的API无缝集成。',
    },
    developerApi: {
      title: '开发者优先API',
      description: '具有全面文档、SDK和开发者工具的RESTful API。由开发者为DevSecOps工作流程构建。',
    },
  },

  // Testimonials
  testimonials: {
    title: '受全球开发者信任',
    testimonial1: {
      text: 'AuthFlow™为我们节省了数月开发时间。集成无缝，安全功能是企业级的。',
      author: 'Sarah Johnson',
      role: 'CTO, TechStart',
    },
    testimonial2: {
      text: '分析仪表板为我们提供了对用户行为的惊人洞察。我们使用过的最好的认证解决方案。',
      author: 'Mike Rodriguez',
      role: '首席开发者, AppCorp',
    },
    testimonial3: {
      text: '坚如磐石的可靠性和优秀支持。我们的用户喜欢流畅的认证体验。',
      author: 'Alex Liu',
      role: '产品经理, InnovateLab',
    },
  },

  // CTA Section
  cta: {
    title: '准备添加可靠的认证？',
    description: '加入选择简单、有效的电子邮件/密码认证与JWT令牌的开发者。今天开始您的免费试用。',
    startTrial: '开始免费试用',
  },

  // About Page
  about: {
    title: '关于AuthFlow™ - 简单电子邮件/密码认证专家',
    description: '了解AuthFlow™提供可靠电子邮件/密码认证与JWT令牌的使命。成立于2023年，我们为每个开发者简化安全登录。',
    keywords: [
      '电子邮件密码认证',
      'JWT认证公司',
      '认证专家',
      '简单认证',
      '安全登录公司',
      '开发者认证',
      '可靠认证',
      '基于令牌的认证',
      'Web应用程序安全',
      '认证平台'
    ],
    ogTitle: '关于AuthFlow™ - 简单电子邮件/密码认证专家',
    ogDescription: '了解我们提供可靠电子邮件/密码认证与JWT令牌的使命。与复杂的平台不同，我们专注于有效的东西。',
    hero: {
      badge: '成立于2023年',
      title: '构建',
      titleAccent: '简单认证的未来',
      description: '我们的使命是使每个开发者都能使用JWT令牌的电子邮件/密码认证，消除从头构建认证的复杂性和安全风险。',
    },
    mission: {
      title: '我们的使命',
      description1: '使安全、基于令牌的认证民主化，这些认证易于实现和维护。我们相信每个应用程序都应该拥有简单、可靠的电子邮件/密码认证与JWT令牌，而没有过度工程化平台的复杂性。',
      description2: '我们通过设计优先考虑隐私和合规 - 最小化数据收集，在传输和静态时加密敏感信息，并提供可配置的保留政策。我们的目标是帮助团队在不牺牲可用性或开发者速度的情况下满足监管要求。',
      description3: '通过抽象掉过度工程化安全协议、安全通过模糊性和用户管理的复杂性，我们使开发者能够专注于他们最擅长的事情：使用可靠认证构建令人惊叹的产品。',
    },
    vision: {
      title: '我们的愿景',
      description1: '一个认证简单可靠的世界。我们设想一个未来，每个Web应用程序都能访问可信的电子邮件/密码认证与JWT令牌，而没有过度工程化平台的复杂性和不可靠性。',
      description2: '通过持续创新和社区驱动开发，我们正在构建专注于重要事情的认证基础设施：开发者可以依赖的安全、简单登录。',
    },
    values: {
      title: '我们的价值观',
      subtitle: '指导AuthFlow™一切的原则。',
      reliableSecurity: {
        title: '可靠安全',
        description: '我们专注于有效的久经考验的安全实践。电子邮件/密码认证与正确的JWT令牌管理 - 没有不必要的复杂性。',
      },
      developerFirst: {
        title: '开发者优先API',
        description: '我们痴迷于使我们的工具直观、文档完善和令人愉悦使用。伟大的开发者体验导致更好的开发者设计的具有安全认证的产品。',
      },
      communityDriven: {
        title: '社区驱动',
        description: '我们的路线图由您开发者客户塑造。我们倾听、学习，并基于现实世界的安全需求构建。',
      },
    },
    team: {
      title: '认识我们的团队',
      subtitle: '构建认证未来的热情人士。',
      alex: {
        initials: 'AJ',
        name: 'Alex Johnson',
        role: 'CEO & 联合创始人',
        bio: '前美国大型跨国金融机构DevSecOps。热衷于使所有开发者都能使用可靠的电子邮件/密码认证。',
      },
      sarah: {
        initials: 'SC',
        name: 'Sarah Chen',
        role: 'CTO & 联合创始人',
        bio: '拥有10+年构建可靠认证系统的全栈架构师。电子邮件/密码认证和JWT令牌管理专家。',
      },
      marcus: {
        initials: 'MR',
        name: 'Marcus Rodriguez',
        role: '产品主管',
        bio: '专注于开发者体验和可靠认证的产品领导者。简单、有效的电子邮件/密码登录系统专家。',
      },
    },
    stats: {
      title: 'AuthFlow™数据',
      developers: '开发者信任我们',
      authentications: '每月认证',
      uptime: '正常运行时间',
      monitoring: '安全监控',
    },
    cta: {
      title: '加入我们的使命',
      description: '准备成为认证革命的一部分？今天开始使用可靠的电子邮件/密码认证构建。',
      getStarted: '免费开始',
      contactUs: '联系我们',
    },
    breadcrumb: {
      company: '公司',
      aboutUs: '关于我们',
    },
  },

  // Sign In Page
  signIn: {
    title: '欢迎回来',
    subtitle: '登录您的电子邮件/密码认证',
    card: {
      title: '组织登录',
      description: '输入您的组织所有者电子邮件以访问您的JWT认证仪表板',
    },
    form: {
      email: {
        label: '电子邮件',
        placeholder: 'owner@yourorganization.com',
      },
      password: {
        label: '密码',
        placeholder: '输入您的密码',
      },
      signIn: '登录',
      signingIn: '登录中...',
      noAccount: {
        text: '没有组织？',
        link: '创建一个',
      },
    },
    errors: {
      emailRequired: '需要电子邮件',
      failed: '登录失败',
      unexpected: '发生意外错误。请重试。',
    },
    success: {
      message: '成功登录！',
    },
    agreement: {
      text: '登录即表示您同意我们的',
      terms: '服务条款',
      and: '和',
      privacy: '隐私政策',
    },
  },

  // Sign Up
  signUp: {
    title: '创建您的组织',
    subtitle: '使用电子邮件/密码认证开始您的组织',
    card: {
      title: '创建组织',
      description: '设置您的组织以开始使用电子邮件/密码认证和JWT令牌',
    },
    form: {
      organizationName: {
        label: '组织名称',
        placeholder: '您的组织',
      },
      organizationWebsite: {
        label: '组织网站',
        placeholder: 'yourorganization.com',
      },
      emailOwner: {
        label: '所有者电子邮件',
        placeholder: 'owner@yourorganization.com',
      },
      password: {
        label: '密码',
        placeholder: '创建一个强密码',
      },
      confirmPassword: {
        label: '确认密码',
        placeholder: '确认您的密码',
      },
      agreeToTerms: '我同意服务条款和隐私政策',
      acceptMarketing: '向我发送产品更新和营销电子邮件',
      createOrganization: '创建组织',
      creatingOrganization: '创建组织中...',
      haveAccount: {
        text: '已经有账户？',
        link: '登录',
      },
    },
    errors: {
      organizationNameRequired: '需要组织名称',
      organizationWebsiteRequired: '需要组织网站',
      emailRequired: '需要电子邮件',
      passwordRequired: '需要密码',
      passwordsDoNotMatch: '密码不匹配',
      agreeToTermsRequired: '您必须同意服务条款和隐私政策',
      failed: '创建组织失败',
      unexpected: '发生意外错误。请重试。',
    },
    success: {
      message: '组织创建成功！',
    },
    trial: {
      description: '今天开始管理您的组织的认证。',
      features: {
        emailPassword: '电子邮件/密码认证',
        jwtTokens: 'JWT令牌安全',
        simpleLogin: '简单登录',
      },
    },
  },

  // Pricing Page
  pricing: {
    title: 'AuthFlow™定价 - 简单电子邮件/密码认证成本',
    description: '使用JWT令牌的电子邮件/密码认证的简单、透明定价。免费开始并随着增长扩展。没有隐藏费用，可靠认证定价。',
    keywords: [
      '认证定价',
      '电子邮件密码定价',
      'JWT定价',
      '简单认证定价',
      '开发者认证定价',
      '可靠认证成本',
      '安全登录定价',
      '基于令牌的认证定价',
      '免费认证试用'
    ],
    ogTitle: 'AuthFlow™定价 - 简单电子邮件/密码认证成本',
    ogDescription: '为您的需求选择完美计划。使用可靠的电子邮件/密码认证和JWT令牌免费开始并随着增长扩展。',
    hero: {
      title: '简单、透明',
      titleAccent: '认证定价',
      description: '为您的认证需求选择完美计划。使用JWT会话令牌的电子邮件/密码认证免费开始并随着增长扩展。没有隐藏费用，没有惊喜。',
    },
    breadcrumb: {
      product: '产品',
      pricing: '定价',
    },
    plans: {
      starter: {
        name: '入门',
        description: '完美适合小型项目和测试电子邮件/密码认证',
        price: '$0',
        period: '/月',
        features: {
          users: '最多10每月活跃用户',
          basicAuth: '基本电子邮件/密码认证',
          support: '标准支持',
        },
        cta: '免费开始',
      },
      pro: {
        name: '专业',
        description: '适合需要可靠电子邮件/密码认证的成长型企业',
        price: '$9.99',
        period: '首月，然后$19.99/月',
        badge: '最受欢迎',
        features: {
          users: '无限每月活跃用户',
          advancedAuth: '高级电子邮件/密码认证',
          support: '优先支持',
        },
        cta: '开始免费试用',
        monthlyCta: '购买月付',
        annualCta: '购买年付',
      },
    },
    faq: {
      title: '常见问题',
      subtitle: '您需要了解的关于我们的电子邮件/密码认证定价和计划的一切。',
      questions: {
        mau: {
          question: '什么是每月活跃用户？',
          answer: '每月活跃用户（MAU）是在日历月内至少一次使用您的应用程序进行认证的唯一用户。',
        },
        changePlans: {
          question: '我可以随时更改计划吗？',
          answer: '是的，您可以随时升级或降级您的计划。更改立即生效，账单按比例计算。',
        },
        freeTrial: {
          question: '有免费试用吗？',
          answer: '是的，所有付费计划都附带14天免费试用。开始无需信用卡。',
        },
        paymentMethods: {
          question: '您接受哪些付款方式？',
          answer: '我们接受所有主要信用卡、Google Pay和Apple Pay。',
        },
      },
    },
    cta: {
      title: '准备开始了吗？',
      description: '加入信任AuthFlow™进行可靠电子邮件/密码认证的数千开发者。今天开始您的免费试用。',
      startTrial: '开始免费试用',
      contactSales: '联系销售',
    },
    footer: {
      description: '使用JWT令牌的简单、可靠电子邮件/密码认证。受全球开发者信任。',
      product: {
        title: '产品',
        features: '功能',
        pricing: '定价',
        apiReference: 'API参考',
      },
      resources: {
        title: '资源',
        gettingStarted: '开始使用',
        apiReference: 'API参考',
        support: '支持',
      },
      company: {
        title: '公司',
        about: '关于',
        privacyPolicy: '隐私政策',
        termsOfService: '服务条款',
      },
      copyright: '© 2024 AuthFlow™。保留所有权利。',
    },
  },

  // Get Started Page
  getStarted: {
    title: 'AuthFlow™开始使用 - 电子邮件/密码认证设置指南 | JWT API集成',
    description: '使用AuthFlow™实现电子邮件/密码认证的完整指南。在几分钟内设置JWT令牌以进行安全登录。开发者友好的API用于可靠认证。',
    keywords: [
      '认证设置',
      '电子邮件密码认证',
      'JWT集成',
      '安全登录指南',
      '开发者认证',
      'API认证教程',
      '基于令牌的认证',
      '认证API指南'
    ],
    ogTitle: 'AuthFlow™开始使用 - 电子邮件/密码认证设置指南 | JWT API集成',
    ogDescription: '使用AuthFlow™实现电子邮件/密码认证的完整指南。在几分钟内设置JWT令牌以进行安全登录。',
    breadcrumb: {
      resources: '资源',
      getStarted: '开始使用',
    },
    hero: {
      badge: '快速设置指南',
      title: '开始使用',
      titleAccent: '电子邮件/密码认证',
      description: '在几分钟内为您的应用程序添加安全的电子邮件/密码登录与JWT令牌。按照我们的简单设置指南，您将很快使用可靠认证运行。',
      createAccount: '创建免费账户',
    },
    steps: {
      title: '三个简单步骤实现安全的电子邮件/密码认证',
      subtitle: '按照这些步骤将AuthFlow™的电子邮件/密码认证端点集成到您的后端应用程序中。',
      step1: {
        number: '1',
        title: '创建您的账户',
        description: '注册AuthFlow™并创建您的第一个项目。您将立即获得服务器端API密钥以进行安全的电子邮件/密码认证。',
        signUp: '免费注册',
        viewDemo: '查看演示',
      },
      step2: {
        number: '2',
        title: '集成认证端点',
        description: '从您的后端使用我们的/auth端点来处理用户认证。所有端点都需要您的组织的API密钥以进行安全的电子邮件/密码登录。',
        features: {
          apiKeyRequired: '需要API密钥',
          apiKeyDescription: '所有/auth端点都需要JWT令牌中的组织API密钥以进行安全的电子邮件/密码认证',
          backendIntegration: '后端集成',
          backendDescription: '从您的服务器端代码调用，从不将API密钥暴露给前端',
          sessionManagement: '会话管理',
          sessionDescription: '使用包含组织API密钥的JWT令牌处理用户会话以进行可靠的电子邮件/密码认证',
        },
      },
      step3: {
        number: '3',
        title: '添加认证',
        description: '用您的提供者包装您的应用程序并开始使用认证组件。使用可靠的电子邮件/密码认证就是这么简单！🤝',
        quickStart: '快速开始',
        fullDocumentation: '完整文档',
      },
    },
    apiDocs: {
      title: '电子邮件/密码认证的/auth API端点技术指南',
      subtitle: '将AuthFlow™的电子邮件/密码认证端点集成到您的后端应用程序的完整技术文档。',
      apiKeySetup: {
        title: 'API密钥配置',
        description: '您的组织的API密钥嵌入在所有/auth端点的JWT令牌中。为可靠的电子邮件/密码认证，将其安全存储在您的后端环境变量中。',
        envVars: '# 环境变量',
        apiKeyVar: 'AUTHFLOW_API_KEY=af_your_api_key_here',
        baseUrlVar: 'AUTHFLOW_BASE_URL=https://api.authflow.net',
        securityNote: '安全注意：永远不要在前端代码或客户端JavaScript中暴露您的API密钥。所有/auth端点调用必须从您的后端服务器进行，以进行安全的电子邮件/密码认证。',
      },
      endpoints: {
        foobar: {
          title: 'GET /auth/fooBar',
          description: '为认证流程生成临时反滥用令牌',
          params: '参数：',
          identityParam: 'identity (string): 用户的电子邮件地址',
          response: '响应：',
          example: 'Node.js示例：',
        },
        signUp: {
          title: 'POST /auth/signUp',
          description: '在您的组织内创建新用户账户',
          params: '参数：',
          foobarParam: 'foobar (string): 来自/auth/fooBar的令牌',
          apiKeyParam: 'api_key (string): 您的组织的API密钥',
          emailParam: 'email (string): 用户的电子邮件地址',
          passwordParam: 'password (string): 用户的密码（8-32个字符，大写、小写、数字、特殊字符）',
          fullnameParam: 'fullname (string): 用户的全名',
          disclaimedParam: 'disclaimed (string): 必须是"true"',
          response: '响应：',
          example: 'Node.js示例：',
        },
        login: {
          title: 'POST /auth/login',
          description: '认证用户并接收会话令牌',
          params: '参数：',
          foobarParam: 'foobar (string): 来自/auth/fooBar的令牌',
          emailParam: 'email (string): 用户的电子邮件地址',
          passwordParam: 'password (string): 用户的密码',
          apiKeyParam: 'api_key (string): Organization API key',
          response: '响应：',
          tokenNote: '返回的 JWT 包含已认证用户上下文',
          example: 'Node.js示例：',
        },
        validate: {
          title: 'GET /auth/validate',
          description: '验证用户会话令牌并检查认证状态',
          params: '参数：',
          sessionTokenParam: 'sessionToken (string): 来自/auth/login的JWT',
          emailParam: 'email (string): 用户的电子邮件地址',
          response: '响应：',
          example: 'Node.js示例：',
        },
        changePassword: {
          title: 'POST /auth/changePassword',
          description: '允许认证用户更改他们的密码',
          params: '参数：',
          sessionTokenParam: 'sessionToken (string): 来自/auth/login的JWT',
          emailParam: 'email (string): 用户的电子邮件地址',
          newPasswordParam: 'newPassword (string): 新密码（相同复杂性要求）',
          response: '响应：',
          example: 'Node.js示例：',
        },
        logout: {
          title: 'GET /auth/logout',
          description: '安全结束用户会话',
          params: '参数：',
          sessionTokenParam: 'sessionToken (string): 来自/auth/login的JWT',
          emailParam: 'email (string): 用户的电子邮件地址',
          response: '响应：',
          example: 'Node.js示例：',
        },
      },
      implementation: {
        title: '完整后端集成示例',
        notes: '实现注意事项：',
        note1: '安全存储会话令牌（推荐HTTP-only cookies）',
        note2: '在处理请求之前在受保护路由上验证会话',
        note3: '根据需要处理令牌过期和刷新',
        note4: '记录认证事件以进行安全监控',
      },
      errorHandling: {
        title: '错误处理和安全',
        statusCodes: '常见HTTP状态码：',
        status200: '200: 成功',
        status400: '400: 错误请求（缺少/无效参数）',
        status401: '401: 未授权（无效令牌、错误API密钥等）',
        status404: '404: 未找到用户',
        status409: '409: 组织已存在（注册）',
        status500: '500: 服务器错误',
        securityPractices: '安全最佳实践：',
        practice1: '在处理请求之前始终验证JWT令牌',
        practice2: '对所有API调用使用HTTPS',
        practice3: '在认证端点上实施速率限制',
        practice4: '将会话令牌存储在HTTP-only、安全的cookies中',
        practice5: '记录所有认证尝试以进行安全监控',
        practice6: '永远不要记录密码或API密钥等敏感数据',
        criticalNote: '关键：所有/auth端点必须仅从您的后端服务器调用。永远不要在客户端JavaScript中暴露您的API密钥或进行这些调用，因为这会损害您组织的安',
      },
    },
    features: {
      title: '使用电子邮件/密码认证开箱即用',
      subtitle: '连接端点，我们为您提供可靠JWT令牌的会话。就是这么简单！🤝',
    },
    cta: {
      title: '准备添加可靠的电子邮件/密码认证？',
      description: '今天开始您的免费试用，到今天结束时让JWT认证运行。',
      createAccount: '创建免费账户',
      talkToSales: '与销售洽谈',
    },
    parameters: '参数',
    response: '响应',
    example: '示例',
    runFailureScenario: '作为故障场景运行',
    failureScenarioOn: '故障场景：开启',
    running: '运行中...',
    runCurlConsole: '在控制台中运行 cURL',
    copied: '已复制！',
    copyCurl: '复制 curl',
    copyBackendExample: '复制后端代码',
    required: '必需',
    optional: '可选',
    consoleRunning: '控制台正在运行...',
    consoleDemoTitle: 'Linux 控制台演示',
    consoleShellLabel: 'bash -- AuthFlow™ 控制台',
    notesTitle: '说明',
    endpointContent: {
      session: {
        fooBar: {
          summary: '在注册或登录前生成短时效 anti-abuse 令牌。',
          params: {
            identity: '认证用户的邮箱地址。',
            apiKey: '来自 AuthFlow™ 所有者控制台的组织 API key。',
            role: '要编码进临时令牌的 RBAC 角色。默认值为 user。',
          },
          notes: {
            expires: '该令牌 45 秒后过期。',
            freshToken: '请在每次注册或登录前立即获取新的 fooBar anti-abuse 令牌。',
          },
        },
        signUp: {
          summary: '在所有者组织内创建新的认证用户。',
          params: {
            foobar: '由 /auth/fooBar 返回的临时 anti-abuse 令牌。',
            email: '用户邮箱地址。',
            password: '满足 {passwordRule} 的密码。',
            fullname: '认证用户的全名。',
            role: '你应用内该用户的 RBAC 角色。',
            apiKey: '组织 API key。',
            disclaimed: '随用户记录存储的布尔值。集合中使用 true。',
          },
          notes: {
            successToken: '注册成功后会立即返回会话令牌。',
            duplicateRole: '如果组织内已存在相同 email+role，API 会返回 409 payload。',
          },
        },
        login: {
          summary: '认证用户并返回会话令牌或 2FA 挑战。',
          params: {
            foobar: '由 /auth/fooBar 返回的临时 anti-abuse 令牌。',
            email: '用户邮箱地址。',
            password: '用户密码。',
            apiKey: '组织 API key。',
            role: '用于 RBAC 登录的用户角色。',
          },
          notes: {
            tempTokenInsteadOfToken: '启用 2FA 时，login 返回 tempToken 而非 token。',
            exchangeThrough2fa: '随后通过 /auth/2fa 的某个验证端点交换 tempToken。',
          },
        },
        validate: {
          summary: '验证认证用户的会话令牌。',
          params: {
            sessionToken: 'RS512 JWT 会话令牌。',
            email: '用户邮箱地址。',
          },
        },
        me: {
          summary: '在会话有效时返回当前认证用户资料。',
          params: {
            sessionToken: 'RS512 JWT 会话令牌。',
          },
        },
        logout: {
          summary: '退出当前认证用户。',
          params: {
            sessionToken: 'RS512 JWT 会话令牌。',
            email: '用户邮箱地址。',
          },
        },
      },
      passwordManagement: {
        forgotPassword: {
          summary: '为认证用户请求密码重置邮件（防枚举响应）。',
          params: {
            email: '认证用户邮箱地址。',
            apiKey: '组织 API key。',
            role: '认证用户角色。默认值为 user。',
          },
        },
        resetPassword: {
          summary: '使用有效重置令牌重置认证用户密码。',
          params: {
            token: '来自邮件链接的密码重置令牌。',
            newPassword: '满足 {passwordRule} 的新密码。',
          },
        },
        changePassword: {
          summary: '修改已认证用户的密码。',
          params: {
            sessionToken: '当前 RS512 JWT 会话令牌。',
            email: '编码在会话令牌中的邮箱。',
            oldPassword: '用于确认的当前密码。',
            newPassword: '满足 {passwordRule} 的替换密码。',
          },
        },
      },
      emailVerification: {
        verifyEmail: {
          summary: '使用 AuthFlow™ 邮件中的令牌验证认证用户邮箱。',
          params: {
            token: '来自邮箱验证链接的验证令牌。',
          },
          notes: {
            openedFromEmail: '该端点通常通过点击邮件中的验证链接打开。',
            frontendHostedProxy: 'AuthFlow™ 也支持通过 /verify-email 进行前端托管验证，并代理这项检查。',
          },
        },
        resendVerifyEmail: {
          summary: '当账户尚未验证时，重新发送认证用户验证邮件。',
          params: {
            foobar: '由 /auth/fooBar 返回的临时令牌。',
            email: '认证用户邮箱地址。',
            apiKey: '组织 API key。',
            role: '认证用户角色。默认值为 user。',
          },
        },
      },
      twoFactor: {
        enable: {
          summary: '为认证用户生成 TOTP 密钥和二维码。',
          params: {
            sessionToken: '当前会话令牌。',
            email: '认证用户邮箱。',
            apiKey: '组织 UUID。',
            role: '认证用户角色。',
          },
        },
        verifySetup: {
          summary: '验证初始 TOTP 代码并启用 2FA。',
          params: {
            sessionToken: '当前会话令牌。',
            email: '认证用户邮箱。',
            apiKey: '组织 UUID。',
            role: '认证用户角色。',
            totpCode: '来自身份验证器应用的六位代码。',
            secret: '由 /auth/2fa/enable 返回的 TOTP 密钥。',
          },
        },
        disable: {
          summary: '为认证用户禁用 TOTP 2FA。',
          params: {
            sessionToken: '当前会话令牌。',
            email: '认证用户邮箱。',
            apiKey: '组织 UUID。',
            role: '认证用户角色。',
            password: '当前密码。',
          },
        },
        verify2fa: {
          summary: '将登录 tempToken 与 TOTP 代码交换为会话令牌。',
          params: {
            tempToken: '启用 2FA 时 /auth/login 返回的 tempToken。',
            email: '认证用户邮箱。',
            apiKey: '组织 UUID。',
            role: '认证用户角色。',
            totpCode: '六位身份验证器代码。',
          },
        },
        backupEmail: {
          summary: '使用登录 tempToken 发送备用邮箱 OTP。',
          params: {
            tempToken: '由 /auth/login 返回的 tempToken。',
            email: '认证用户邮箱。',
            apiKey: '组织 UUID。',
            role: '认证用户角色。',
          },
        },
        verifyEmailOtp: {
          summary: '将邮件 OTP 交换为会话令牌。',
          params: {
            email: '认证用户邮箱。',
            apiKey: '组织 UUID。',
            role: '认证用户角色。',
            emailOtp: '通过邮件发送的六位代码。',
          },
        },
        recoveryCodes: {
          summary: '为认证用户重新生成恢复码。',
          params: {
            sessionToken: '当前会话令牌。',
            email: '认证用户邮箱。',
            apiKey: '组织 UUID。',
            role: '认证用户角色。',
            password: '当前密码。',
          },
        },
        verifyRecovery: {
          summary: '将恢复码交换为会话令牌。',
          params: {
            email: '认证用户邮箱。',
            apiKey: '组织 UUID。',
            role: '认证用户角色。',
            recoveryCode: '此前返回的 8 位恢复码之一。',
          },
        },
      },
      environment: {
        baseUrl: '公开 API 源地址。',
        apiKey: '所有者控制台 API key。仅存储在服务端。',
        defaultRole: '分配给认证用户的角色/RBAC 值。',
      },
    },
    console: {
      promptPrefix: 'owner@authflow-demo:~$',
      launching: '正在启动 AuthFlow™ Linux Console v1.0 ...',
      kernel: '内核: Linux 6.8.0-35-generic x86_64',
      curlVersion: 'curl: 8.5.0, OpenSSL: 3.0.x',
      connected: '已连接到 api.authflow.net',
      sending: '> 正在发送 {method} {path}',
      waiting: '> 正在等待响应 ...',
      serverHeader: '< server: api.authflow.net',
      processExited: '[进程已退出，代码 {code}]',
      status: {
        defaultSuccess: 'HTTP/1.1 200 OK (示例)',
        signup: {
          success: 'HTTP/1.1 201 Created (示例)',
          alt409: '# alt: 当 email+role 已存在时返回 HTTP/1.1 409 Conflict',
        },
        login: {
          success: 'HTTP/1.1 200 OK (示例)',
          alt2fa: '# alt: 启用 2FA 时返回 requires2FA/tempToken payload',
        },
        verifyEmail: {
          success: 'HTTP/1.1 200 OK (示例)',
          alt401: '# alt: 验证令牌无效或过期时返回 HTTP/1.1 401 Unauthorized',
        },
        validate: {
          success: 'HTTP/1.1 200 OK (示例)',
          alt401: '# alt: 会话令牌无效或过期时返回 HTTP/1.1 401 Unauthorized',
        },
        forgotPassword: {
          success: 'HTTP/1.1 200 OK (防枚举响应)',
        },
        changePassword: {
          success: 'HTTP/1.1 200 OK (示例)',
          noJsonBody: '# 成功时无 JSON 响应体',
        },
      },
      failure: {
        signup: {
          status: 'HTTP/1.1 409 Conflict (示例)',
          extra: '# 故障场景：email+role 重复',
        },
        login: {
          status: 'HTTP/1.1 400 Bad Request (示例)',
          extra: '# 故障场景：凭据无效或角色不匹配',
        },
        verifyEmail: {
          status: 'HTTP/1.1 401 Unauthorized (示例)',
          extra: '# 故障场景：验证令牌已失效',
        },
        validate: {
          status: 'HTTP/1.1 401 Unauthorized (示例)',
          extra: '# 故障场景：会话令牌已过期',
        },
        me: {
          status: 'HTTP/1.1 401 Unauthorized (示例)',
          extra: '# 故障场景：缺少或无效 sessionToken',
        },
        logout: {
          status: 'HTTP/1.1 401 Unauthorized (示例)',
          extra: '# 故障场景：sessionToken 无效',
        },
        changePassword: {
          status: 'HTTP/1.1 401 Unauthorized (示例)',
          extra: '# 故障场景：oldPassword 错误或会话已过期',
        },
        resendVerifyEmail: {
          status: 'HTTP/1.1 401 Unauthorized (示例)',
          extra: '# 故障场景：foobar 令牌过期或 api_key 无效',
        },
        fooBar: {
          status: 'HTTP/1.1 400 Bad Request (示例)',
          extra: '# 故障场景：缺少 identity 或 api_key',
        },
        forgotPassword: {
          status: 'HTTP/1.1 400 Bad Request (示例)',
          extra: '# 故障场景：缺少 email 或 api_key',
        },
        resetPassword: {
          status: 'HTTP/1.1 401 Unauthorized (示例)',
          extra: '# 故障场景：重置令牌过期',
        },
        default: {
          status: 'HTTP/1.1 400 Bad Request (示例)',
          extra: '# 故障场景',
        },
      },
    },
    pageContent: {
      badge: '认证产品参考',
      title: 'AuthFlow™ API 文档',
      titleAccent: '面向组织所有者',
      description: '本 Get Started 页面记录了面向贵组织用户的公共 auth API。AuthFlow™ 共提供 20 条 /auth 路由：7 条 session 路由用于认证与用户管理，3 条 passwordManagement 路由用于密码重置，2 条 emailVerification 路由用于邮箱验证，8 条 twoFactor 路由用于双因素认证。下方可下载的 Insomnia 集合包含与 API 合同完全一致的全部端点定义、参数和示例请求。',
      downloadCollection: '下载 Insomnia 集合',
      createAccount: '创建所有者账户',
      cloneStarterOnGitHub: '克隆 Next.js 起始模板',
      starterInfoLabel: '有关 Next.js 起始模板的重要安全信息',
      starterWarningTitle: '仅限原型和概念验证使用',
      starterWarningPrototype: 'authflow-nextjs-starter 仅适用于原型和概念验证前端，不得作为生产环境中的浏览器集成。',
      starterWarningSecret: '切勿将 AuthFlow API 密钥放入生产前端代码、浏览器可见的环境变量、静态资源或客户端软件包中。任何发送到浏览器的内容都可能被用户和攻击者读取。',
      starterWarningProduction: '在生产环境中，请通过可信的服务端后端或 AuthFlow ExpressJS 代理发送身份验证请求，并将 API 密钥保存在服务端环境变量或托管密钥存储中。',
      apiKeyWarningTitle: '切勿在生产环境的浏览器代码中暴露 AuthFlow API 密钥。',
      apiKeyWarningBody: 'API 密钥必须保留在您控制的基础设施中。请勿将其嵌入 JavaScript 软件包、HTML、公共环境变量、移动 Web 资源、日志或浏览器直接发出的网络请求中。请使用此 ExpressJS 代理或您自己的后端，确保密钥始终保留在服务端。',
      integrationRulesTitle: '集成规则',
      integrationRulesRules: [
        '组织所有者只能从服务端渲染代码调用 AuthFlow™。浏览器应用应将密钥作为服务端环境变量存储，再由服务端调用 AuthFlow™ API。原因是：与大多数认证服务不同，AuthFlow™ 设计为 server-to-server 使用，以满足通用 NIST 标准合规要求。',
        '组织所有者（你）的 API key 是核心会话管理路由及其他路由的必需项。',
        'fooBar token 是短时效的反滥用令牌，应在每次注册或登录前立即获取，确保始终新鲜且有效。',
        '如果登录返回 requires2FA（表示用户已启用 2FA），则用户必须完成文档中的某个 /auth/2fa 验证交换，才能获取会话令牌。',
      ],
      ownerAssetsTitle: '所有者资源',
      ownerAssetsText: '请使用你的实施团队可直接导入 Insomnia 的完整集合。',
      ownerAssetsCollectionName: 'AuthFlow_Consumers.yaml',
      collectionIncludes: '集合包含：',
      collectionItems: [
        '7 条公开 /auth session 路由',
        '3 条公开 /auth passwordManagement 路由',
        '2 条公开 /auth emailVerification 路由',
        '8 条公开 /auth/2fa twoFactor 路由',
        '用于 API key、角色/RBAC、会话令牌、TOTP、临时令牌和恢复码流程的环境变量',
      ],
      checklistTitle: '实施清单',
      checklistSubtitle: '这是建议的组织所有者工作流，用于通过 AuthFlow™ 将你的组织接入认证体系。',
      configStep: '1. 配置服务端密钥',
      implementStep: '2. 实现服务端认证',
      connectStep: '3. 连接你的前端',
      connectStepSecurityNote: '你的浏览器端代码绝不应存储 AuthFlow™ API 密钥等机密信息（例如所有者 API key）。',
      implementStepRules: [
        '获取 /auth/fooBar',
        '调用 /auth/signUp 或 /auth/login',
        '安全存储会话令牌',
        '在受保护路由中使用 /auth/validate、/auth/me、/auth/changePassword 和 /auth/logout',
      ],
      connectStepRules: [
        '提交登录和注册表单',
        '当 API 返回 requires2FA 时处理 2FA 提示',
        '将应用会话存储在安全 Cookie 中',
        '通过 session 端点响应加载当前用户',
      ],
      sessionEndpointsTitle: '会话端点',
      sessionEndpointsSubtitle: '这 7 条路由对应后端根端点中的 authProduct.session。',
      passwordMgmtTitle: '密码管理端点',
      passwordMgmtSubtitle: '这 3 条路由对应后端根端点中的 authProduct.passwordManagement。',
      emailVerificationTitle: '邮箱验证端点',
      emailVerificationSubtitle: '这 2 条路由对应后端根端点中的 authProduct.emailVerification。',
      twoFactorTitle: '双因素端点',
      twoFactorSubtitle: '这 8 条路由对应后端根端点中的 authProduct.twoFactor。',
      serviceExampleTitle: '服务示例',
      securityRequirementsTitle: '安全要求',
      securityRequirements: [
        '将 AUTHFLOW_API_KEY 保存在服务端并加密。',
        '应用会话优先使用安全的 HTTP-only Cookie。',
        '在提供受保护用户数据前先验证 AuthFlow™ 会话。',
        '在集成中显式处理 400、401、404、409 和 500 响应。',
      ],
      readyCtaTitle: '准备好接入你公司的认证了吗？',
      readyCtaDescription: '从可下载集合开始，使用安全存储的密钥完成服务的安全集成；如需帮助，可使用本页助手。',
      proxyTitlePrefix: 'ExpressJS ',
      proxyTitleSuffix: ' 代理',
      proxyDescriptionPrefix: '你也可以在自己的 ExpressJS 后端中代理 AuthFlow 后端。这可以说是将 ',
      proxyDescriptionSuffix: ' 用于你的应用技术栈时最安全的方式。',
      proxyDetailsRoutes: '该代理会转发 AuthFlow 的全部 /auth/* 与 /auth/2fa/* 路由，将组织 API key 保留在服务端，并帮助避免浏览器代码中暴露密钥。',
      proxyDetailsDeploy: '该代理已可直接部署到 Vercel，支持立即本地开发，并提供注册、登录、密码流程与 2FA 验证的实用示例。',
      proxyButton: '在 GitHub 上查看',
    },
  },

  agent: {
    chatbot: {
      title: 'AuthFlow™ 助手',
      inputPlaceholder: '询问 /auth 或 2FA 集成...',
      greeting: '我会按 AuthFlow™ auth-user 精确合同指导组织所有者。你可以问 owner API key 配置、/auth 端点、2FA 流程、Insomnia 集合、前后端边界或 Settings 页面账号删除。',
      downloadIntro: '使用此直链下载卡片，立即获取可导入的 owner 集合。',
      downloadTitle: '下载 Insomnia 集合',
      downloadButton: '下载',
      noAnswer: '我没有从代理获得可用回答。请询问具体端点、2FA 流程或后端集成步骤。',
      error: '联系助手时发生错误。你仍可询问 /auth 合同、2FA 流程或 Insomnia 集合后重试。',
      toolNotFound: '未找到工具',
    },
    tools: {
      verificationRecoveryDescription: '邮箱验证与密码找回端点',
      accountSteps: ['1. 在 https://www.authflow.net/sign-up 注册组织所有者', '2. 在 owner 控制台创建组织', '3. 从控制台复制组织 API key', '4. 确定你的应用使用的 role 值', '5. 下载 AuthFlow™ auth-user Insomnia 集合', '6. 将集合和精确 backend 合同交给集成团队'],
      accountManagement: ['如需永久删除组织，请前往 AuthFlow™ 控制台 Settings 页面。', '在 Delete Account 区域输入 DELETE 进行不可逆确认。'],
      reminder: 'owner API key 只能放在公司后端。',
      environmentNotes: ['AUTHFLOW_API_KEY 仅可在服务端使用。', 'AUTHFLOW_DEFAULT_ROLE 可选，但通常很有用。', '前端应调用你自己的后端路由，而不是直接调用 AuthFlow™。'],
      backendGuidance: ['在 /auth/signUp 或 /auth/login 前立即获取 /auth/fooBar。', '参数名必须与公共合同完全一致。', '若 /auth/login 返回 requires2FA，请继续调用对应 /auth/2fa 路由。', '通过后端路由校验并查询当前用户，对前端仅暴露你自己的应用会话。'],
      insomniaContains: ['全部 12 个公开 /auth 端点（含 verify-email、resend-verify-email、forgot-password、reset-password、deleteUser）', '全部 8 个公开 /auth/2fa 端点', '包含 API key、role、fooBar token、tempToken、session token、TOTP、邮箱 OTP 和恢复码流程的环境变量'],
      troubleshoot: {
        solutions: {
          cors: '如果浏览器直接调用 AuthFlow™，请先停止。浏览器应调用你的后端，由后端调用 AuthFlow™。',
          '401_unauthorized': '请检查 /auth/fooBar 或登录时使用的 api_key、role、email 是否一致。',
          token_validation: '调用 /auth/validate 时必须使用准确的 sessionToken+email，不要和 tempToken 混用。',
          connection_failed: '确认 AUTHFLOW_BASE_URL 为 https://api.authflow.net 且后端可访问。',
          api_key_invalid: 'owner API key 必须是以 af_ 开头的 dashboard key。',
          foobar_expired: 'fooBar 过期很快，请在 sign-up/login 前立即获取。',
          verification_link: '验证邮件 token 必须有效，并以 query 参数传给 /auth/verify-email。',
          password_reset: '先调用 /auth/forgot-password，再用邮件 token 调用 /auth/reset-password。',
          two_factor_flow: '若 login 返回 requires2FA，请仅在 /auth/2fa 路由中使用 tempToken。',
          organization_deletion: '永久删除组织需在 Settings > Delete Account 中输入 DELETE。',
          other: '请对照公共合同检查：参数名、HTTP 方法以及 query/body/header 位置。',
        },
        commonIssues: ['前端直接调用 AuthFlow™', '/auth/fooBar 或 /auth/login 缺少 api_key 或 role 错误', '/auth/changePassword 的 oldPassword/newPassword 使用错误', 'tempToken 与 sessionToken 混淆', '验证 token 过期或无效', '未先调用 /auth/forgot-password 就调用 /auth/reset-password', 'requires2FA 后未完成 2FA 验证交换', '在 Settings 流程外尝试删除组织'],
      },
    },
  },

  comparisons: {
    hub: {
      breadcrumbRoot: '对比',
      breadcrumbCurrent: '认证产品对比',
      title: '认证产品对比',
      description: '查看 AuthFlow™ 与最流行认证平台的对比表现。并排功能表帮助你为项目选择合适的认证方案。',
      card: {
        firebase: {
          title: 'Firebase vs. Auth0 vs. AuthFlow™',
          description: '对比 Google 的 Firebase Authentication、Auth0 的企业平台，以及以开发者为中心的 AuthFlow™。快速判断哪种认证方案最适合你的技术栈。',
        },
        supabase: {
          title: 'Supabase vs. Auth0 vs. AuthFlow™',
          description: '对比 Supabase 的开源认证、Auth0 的企业方案，以及轻量且聚焦的 AuthFlow™ 认证服务。若你已在 Supabase 生态中，这份对比尤其有价值。',
        },
      },
      bullets: {
        core: '核心认证能力与安全性',
        rbac: '2FA、RBAC 与多租户',
        supabaseModel: '开源 vs. 托管 vs. 聚焦型',
        pricing: '定价与供应商锁定风险',
        dx: '开发者体验与接入复杂度',
      },
      viewComparison: '查看对比',
    },
    labels: {
      fullySupported: '完全支持',
      partial: '部分支持 / 有限制',
      notSupported: '不支持',
      feature: '功能',
      summary: '总结',
      startFree: '使用 AuthFlow™ 免费开始',
      alsoSee: '另请参阅：',
      providers: {
        firebase: 'Firebase Auth',
        supabase: 'Supabase Auth',
        auth0: 'Auth0',
        authflow: 'AuthFlow™',
      },
      categories: {
        core: '核心认证',
        security: '安全',
        userOrg: '用户与组织管理',
        dx: '开发者体验',
        pricing: '定价与灵活性',
      },
    },
    features: {
      emailPassword: '邮箱与密码认证',
      socialLogin: '社交登录（Google、GitHub 等）',
      magicLinks: '魔法链接 / 免密登录',
      smsPhone: '短信 / 手机号认证',
      anonymous: '匿名认证',
      jwt: 'JWT 令牌管理',
      rs512: 'RS512 密钥对签名',
      twofa: '双因素认证（2FA）',
      totp: 'TOTP 认证器应用（Google Auth、Authy）',
      backupCodes: '2FA 备用恢复码',
      emailOtp: '通过邮箱 OTP 的 2FA',
      rateLimiting: '限流（Rate Limiting）',
      emailVerification: '邮箱验证',
      passwordReset: '密码重置 / 忘记密码',
      passwordComplexity: '密码复杂度策略',
      userDashboard: '用户管理控制台',
      rbac: '基于角色的访问控制（RBAC）',
      multiTenancy: '多租户 / 组织',
      perOrgApiKeys: '按组织分配 API Key',
      auditLogs: '审计 / 活动日志',
      userBlocking: '用户封禁 / 暂停',
      simpleRest: '简洁 REST API（无需 SDK）',
      officialSdks: '官方客户端 SDK',
      customEmailTemplates: '自定义邮件模板',
      webhooks: 'Webhook / 事件回调',
      selfHosted: '自托管选项',
      openSource: '开源',
      apiDocs: 'API 文档',
      integratedDb: '集成数据库（PostgreSQL）',
      authOnly: '仅认证（无需数据库）',
      freeTier: '提供免费层',
      flatRate: '可预测的固定价格',
      payPerMau: '按 MAU 计费模式',
      lowLockIn: '低供应商锁定风险',
      lowSetup: '低接入复杂度',
      noEcosystemBuyIn: '无需绑定生态也可使用',
    },
    notes: {
      firebase2fa: 'Firebase 需要升级到 Identity Platform 才能完整使用 2FA。',
      firebaseRest: 'Firebase 以 SDK 为核心；若直接使用纯 REST，需要手动处理令牌交换。',
      firebaseLockIn: 'Firebase 与 Google/Firebase 生态耦合较深。',
      supabaseRls: 'Supabase 在 Postgres 中使用行级安全（RLS）策略。',
      supabaseDb: 'Supabase Auth 与其 Postgres 数据库高度集成。',
      supabaseLockIn: 'Supabase 开源可降低锁定风险，但其认证能力仍与 Postgres 技术栈紧密绑定。',
      supabaseAuthOnly: 'Supabase 可仅用于认证，但整体定位仍是完整后端平台。',
    },
    firebase: {
      breadcrumbCurrent: 'Firebase vs. Auth0 vs. AuthFlow™',
      title: 'Firebase vs. Auth0 vs. AuthFlow™',
      description: '并排对比 Google Firebase Authentication、Okta Auth0 与 AuthFlow™ 的功能差异，帮助你为应用选择最合适的认证层。',
      summary: {
        firebaseTitle: 'Firebase Authentication',
        firebaseBody: '适合已经深度使用 Google/Firebase 生态的团队。免费层较慷慨、SDK 接入体验好，但生态锁定较强，且 2FA 等高级能力通常需要 Identity Platform。',
        auth0Title: 'Auth0',
        auth0Body: '三者中功能最全面，支持 SAML、OIDC、企业 SSO 与深度定制。适合有复杂企业需求的大团队，但价格会随 MAU 快速上升。',
        authflowTitle: 'AuthFlow™',
        authflowBody: '若你需要具备高安全性的邮箱/密码认证（RS512 JWT、2FA、RBAC），又不想被大型生态绑定，AuthFlow™ 是更合适的选择。REST API 简洁、定价可预期、接入复杂度低。',
      },
      alsoSee: 'Supabase vs. Auth0 vs. AuthFlow™',
    },
    supabase: {
      breadcrumbCurrent: 'Supabase vs. Auth0 vs. AuthFlow™',
      title: 'Supabase vs. Auth0 vs. AuthFlow™',
      description: '并排对比 Supabase 开源认证、Auth0 企业平台与 AuthFlow™，帮助你为应用选择最合适的认证层。',
      summary: {
        supabaseTitle: 'Supabase Auth',
        supabaseBody: '适合希望使用开源且可自托管后端的团队。Supabase Auth 功能强大，支持社交登录、魔法链接，并与 Postgres 深度集成。若你已使用 Supabase 作为数据库，会更匹配。',
        auth0Title: 'Auth0',
        auth0Body: '功能覆盖最全面，包括 SAML、OIDC、企业 SSO 与深度定制。适合具有复杂合规要求的大团队，但随月活用户增长，价格上涨明显。',
        authflowTitle: 'AuthFlow™',
        authflowBody: '当你需要稳定、聚焦的邮箱/密码认证，并强调安全性（RS512 JWT、2FA、RBAC）且避免平台锁定时，AuthFlow™ 更合适。REST API 简洁，价格可预测，配置成本低。',
      },
      alsoSee: 'Firebase vs. Auth0 vs. AuthFlow™',
    },
  },

  // Common
  common: {
    loading: '加载中...',
    error: '发生错误',
    success: '成功',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    view: '查看',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    language: '语言',
  },

  // SEO
  seo: {
    title: 'AuthFlow™ - 安全认证变得简单',
    description: 'Web应用程序的基于令牌的认证。轻松集成、企业安全和开发者友好的API。今天开始您的免费试用。',
    keywords: ['认证', '授权', '安全', 'API', '基于令牌的认证', 'JWT', '开发者工具', 'Web安全', '用户管理'],
  },

  // Footer (shared across pages)
  footer: {
    description: '使用JWT令牌的简单、可靠电子邮件/密码认证。受全球开发者信任。',
    product: '产品',
    resources: '资源',
    company: '公司',
    apiReference: 'API参考',
    about: '关于',
    support: '支持',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    copyright: '© 2024 AuthFlow™。保留所有权利。',
  },
} as const
